import React from "react";
import { forwardRef } from "react";

const MFCapitalGainReportTable = forwardRef(
  (
    {
      tableData,
      handleTableScroll,
      scrollLoaderTable,
      loader,
      LoaderForSearch,
      clientDashboard,
    },
    ref
  ) => {
    return (
      <div className="table-responsive scroll-table report-table-wrapper">
      <table className="table last-column">
        <thead>
          <tr>
            <th scope="col">Sr No.
            </th>
            <th scope="col">Segment Type
            </th>
            <th scope="col">ISIN
            </th>
            <th scope="col">Scheme Name
            </th>
            <th scope="col">Units
            </th>
            <th scope="col">Purchase Date
            </th>
            <th scope="col">Purchase NAV
            </th>
            <th scope="col">Purchase Amount
            </th>
            <th scope="col">Sell Date
            </th>
            <th scope="col">Sell NAV
            </th>
            <th scope="col">Sell Amount
            </th>
            <th scope="col">Jan18 NAV
            </th>
            <th scope="col">Jan18 NAV Purchase Amount
            </th>
            <th scope="col">STT
            </th>
            <th scope="col">TDS
            </th>
          </tr>
        </thead>
        <tbody
          onScroll={(e) => handleTableScroll(e)}
          // id="per-table-body"
          ref={ref}
        >
          {tableData?.length > 0 &&
            tableData.map((item, index) => {
              return (
                <tr key={index}>
                  <td>
                    {index + 1}
                  </td>
                  <td>{item?.segmentType}</td>
                  <td>{item?.isin || "-"}</td>
                  <td>{item?.schName || "-"}</td>
                  <td>{item?.units || "-"}</td>
                  <td>{item?.purchDt || "-"}</td>
                  <td>{item?.purchNav || "-"}</td>
                  <td>{item?.purchAmt || "-"}</td>
                  {/* <td>Low Duration Fund</td> */}
                  <td>{item?.sellDt || "-"}</td>
                  <td>{item?.sellNav || "-"}</td>
                  <td>{item?.sellAmt || "-"}</td>
                  <td>{item?.jan18Nav || "-"}</td>
                  <td>{item?.jan18PurchAmt || "-"}</td>
                  <td>{item?.stt || "-"}</td>
                  <td>{item?.tds || "-"}</td>
                </tr>
              );
            })}
          
        </tbody>
        {scrollLoaderTable && !loader && (
            <div className="loader-center">
              <LoaderForSearch />
            </div>
          )}
      </table>
      </div>
    );
  }
);

export default MFCapitalGainReportTable;
